import React, {
    useState, useEffect, useContext, useRef
} from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import Button from '@ferris/react/components/button/Button';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { PROPERTY_MANAGEMENT_IMAGE } from '../../../constants/common';
import { createImpressionEvent } from '../../../utils/EventProviders/EgClickstreamUtil';

const Vacasa = (props) => {
    const {
        title, description, submitLabel, leadFn, closeLabel, isModal, setShowVacasa, open,
        vacasaVariant
    } = props;
    const [isVacasaSectionViewed, setIsVacasaSectionViewed] = useState(false);
    const { trigger } = useContext(TrackingContext);
    const vacasaSection = useRef();

    const isVacasaSectionVisible = () => {
        /* istanbul ignore else */
        if (vacasaSection.current) {
            return (vacasaSection.current.getBoundingClientRect().top
            - (vacasaSection.current.offsetHeight + 150)) < 0;
        }
        return false;
    };

    const onScroll = () => {
        if (isVacasaSectionVisible()) {
            setIsVacasaSectionViewed(true);
        }
    };

    const scrollHandler = throttle(onScroll, 333);

    useEffect(() => {
        if (isModal && open && vacasaVariant === 1) {
            trigger('impression', createImpressionEvent('referral_popup.presented', 'Property Onboarding', 'referral_popup'));
        }
    }, [open]);
    useEffect(() => {
        if (!isModal && vacasaVariant === 2) {
            window.addEventListener('scroll', scrollHandler);
            trigger('impression', createImpressionEvent('referral_section.presented', 'Property Onboarding', 'referral_section'));
        }
        return () => {
            window.removeEventListener('scroll', scrollHandler);
        };
    }, []);
    useEffect(() => {
        if (isVacasaSectionViewed) {
            trigger('impression', createImpressionEvent('referral_section.viewed', 'Property Onboarding', 'referral_section'));
        }
    }, [isVacasaSectionViewed]);

    return (
        <div className="ulx-property-managment-container" ref={vacasaSection}>
            <img alt="property-managment" src={PROPERTY_MANAGEMENT_IMAGE} />
            <div className="ulx-property-managment-body-container">
                <h2>{title}</h2>
                <p>{description}</p>
                <div className="ulx-property-managment-cta-container">
                    <Button
                        htmlButtonType="button"
                        type="primary"
                        onClick={leadFn}
                        small
                    >
                        {submitLabel}
                    </Button>
                    { isModal
                    && (
                        <Button
                            htmlButtonType="button"
                            small
                            type="utility"
                            variant="utility-standard"
                            onClick={() => setShowVacasa(false)}
                        >
                            {closeLabel}
                        </Button>
                    )
                    }
                </div>
            </div>
        </div>
    );
};
Vacasa.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    submitLabel: PropTypes.string.isRequired,
    leadFn: PropTypes.func.isRequired,
    closeLabel: PropTypes.string.isRequired,
    isModal: PropTypes.bool.isRequired,
    open: PropTypes.bool.isRequired,
    setShowVacasa: PropTypes.func.isRequired,
    vacasaVariant: PropTypes.number.isRequired
};

export default Vacasa;
